import React from "react";
import {
	Lockers,
	OutdoorSpace,
	ParkingSpace,
	StorageUnit,
	Wine,
	Workspace
} from "components/core/Icons";

// https://gitlab.com/storable/sparefoot/inventory_service/-/blob/master/lib/units/unit.js#L7

export const unitTypesToIcon = {
	outdoor: <OutdoorSpace />,
	parking_space: <ParkingSpace />,
	workspace: <Workspace />,
	locker: <Lockers />,
	wine_storage: <Wine />,
	storage: <StorageUnit />
};
